import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    name: '',
    userName: '',
    Authorization: '',
    userType: '0',
    userKind: '0'
  },
  mutations: {
    set_Authorization (state, Authorization) {
      state.Authorization = Authorization
      // 安全加固：JWT 仅保留在内存，不再写入 localStorage（防止 XSS 从 localStorage 窃取 token）
      // 刷新后登录态由后端 Cookie（loginByName Set-Cookie 下发）恢复，见 router/index.js
    },
    set_name (state, name) {
      state.name = name
      localStorage.name = name
    },
    set_userName (state, userName) {
      state.userName = userName
      localStorage.userName = userName
    },
    set_userType (state, userType) {
      state.userType = userType
      localStorage.userType = userType
    },
    set_userKind (state, userKind) {
      state.userKind = userKind
      localStorage.userKind = userKind
    },
    del_Authorization (state) {
      state.Authorization = ''
      localStorage.removeItem('Authorization')
    },
    del_name (state) {
      state.name = ''
      localStorage.removeItem('name')
    },
    del_userName (state) {
      state.userName = ''
      localStorage.removeItem('userName')
    },
    del_userType (state) {
      state.userType = 0
      localStorage.removeItem('userType')
    },
    del_userKind (state) {
      state.userKind = 0
      localStorage.removeItem('userKind')
    }
  },
  actions: {
  },
  modules: {
  }
})
